import styled from 'styled-components';
export const SectionContainer = styled.section `
  padding: 60px 20px;
  background: #f8fafc;
  width: 100%;
`;
export const Container = styled.div `
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  padding: 0 20px;
`;
export const SectionHeader = styled.div `
  text-align: center;
  margin-bottom: 4rem;
`;
export const SectionTitle = styled.h2 `
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 700;
  position: relative;
  display: inline-block;
  margin: 0;
  color: #1a1a1a;

  &::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: #ffd700;
    border-radius: 2px;
  }
`;
export const ExperienceTimeline = styled.div `
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2rem 0 3rem 0;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ffd700;
    border-radius: 4px;

    &:hover {
      background: #fdb927;
    }
  }
`;
export const ExperienceContent = styled.div `
  display: flex;
  gap: 2rem;
  padding: 0 20px;
  min-width: fit-content;
`;
export const ExperienceCard = styled.div `
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: ${(props) => (props.$current ? '2px solid #ffd700' : '1px solid #f3f4f6')};
  min-width: 340px;
  width: 340px;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  ${(props) => props.$current
    ? `
    box-shadow: 0px 4px 20px rgba(255, 215, 0, 0.2);

    &::before {
      content: 'Current';
      position: absolute;
      top: 1rem;
      right: 1rem;
      background: linear-gradient(135deg, #FFD700 0%, #FDB927 100%);
      color: #1a1a1a;
      padding: 0.375rem 0.875rem;
      border-radius: 20px;
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  `
    : ''}

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    min-width: 300px;
    width: 300px;
    padding: 1.5rem;
  }
`;
export const ExperienceLogo = styled.img `
  width: 70px;
  height: 70px;
  margin-bottom: 1rem;
  object-fit: contain;
  border-radius: 12px;
  background: #f8fafc;
  padding: 0.5rem;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;
export const CompanyName = styled.h3 `
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.25rem;

  a& {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: #ffd700;
    }
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;
export const JobTitle = styled.p `
  font-size: 1rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 0.5rem;
`;
export const Tenure = styled.p `
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 1rem;
  font-weight: 500;
`;
export const SkillsContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;
export const SkillTag = styled.span `
  display: inline-block;
  background: #f3f4f6;
  color: #374151;
  padding: 0.3rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 500;
`;
export const Description = styled.p `
  color: #4b5563;
  line-height: 1.6;
  font-size: 0.9375rem;
  flex-grow: 1;
`;
